require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-98-my-preferences-dependencies.json") })
        }
      }, "path---article-98-my-preferences-dependencies");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-98-my-preferences-dependencies!./.cache/json/article-98-my-preferences-dependencies.json
// module id = 580
// module chunks = 231608221292675